import { Box, styled, useMediaQuery } from "@mui/material";
import { Button, H2 } from "./";

const BannerContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  borderRadius: "32px",
  overflow: "hidden",
  position: "relative",
  minHeight: "650px",
  "@media (max-width: 600px)": {
    borderRadius: "24px",
    minHeight: "650px",
  },
}));

const BackgroundImage = styled("img")({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
  zIndex: 0,
});

const ContentSection = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  padding: "60px 60px 100px 60px",
  justifyContent: "center",
  zIndex: 1,
  "@media (max-width: 600px)": {
    padding: "60px 16px 32px 16px",
    gap: "24px",
    justifyContent: "flex-start",
    alignItems: "center",
    textAlign: "center",
    height: "100%",
  },
}));

const BannerTitle = styled(H2)(() => ({
  color: "#FFFFFF",
  maxWidth: "480px",
  "@media (max-width: 600px)": {
    fontSize: "28px",
    lineHeight: "34px",
    maxWidth: "100%",
  },
}));

interface BannerSectionProps {
  title: string;
  buttonText?: string;
  imageSrc: string;
  imageAlt?: string;
}

export const BannerSection = ({
  title,
  buttonText = "Попробовать бесплатно",
  imageSrc,
  imageAlt = "Banner",
}: BannerSectionProps) => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  // Auto-generate mobile image path: /path/image.webp -> /path/image-mobile.webp
  const mobileImageSrc = imageSrc?.replace(/(\.[\w\d]+)$/, "-mobile$1");
  const currentImage = isMobile && mobileImageSrc ? mobileImageSrc : imageSrc;

  return (
    <BannerContainer>
      <BackgroundImage src={currentImage} alt={imageAlt} />
      <ContentSection>
        <BannerTitle>{title}</BannerTitle>
        <Box>
          <Button variant="white">{buttonText}</Button>
        </Box>
      </ContentSection>
    </BannerContainer>
  );
};
